import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    clickToSubmitButtonWithEnter,
    handleKeyDownForPhoneNumberInput,
    handlePasteForPhoneNumberInput,
} from "../../Inputs/handleKeyDown";
import { verifyRecoveryCodeRequest } from "./passwordRecoveryRequests";
import { useNavigate } from "react-router-dom";

function PasswordRecoveryStep2({ theme, setTheme }) {
    const [recoveryInputValue, setrecoveryInputValue] = useState("");

    const { t } = useTranslation();

    const passwordInputRef = useRef(null);

    const navigate = useNavigate();

    const [requestStatus, setRequestStatus] = useState({ loading: false, error: null });

    useEffect(() => {
        if (passwordInputRef.current) {
            passwordInputRef.current.focus();
        }

        clickToSubmitButtonWithEnter();
    }, []);


    function maskEmail(email) {
        const [name, domain] = email.split("@");
        if (name.length <= 4) {
            return email;
        }
        const maskedName =
            name.slice(0, 2) +
            "*".repeat(name.length - 4) +
            name.slice(-2);
        return `${maskedName}@${domain}`;
    }

    const passwordRecovery = JSON.parse(
        sessionStorage.getItem("passwordRecovery") || "{}"
    );

    const email = passwordRecovery.email;
    const otpId = passwordRecovery.otpId;

    return (
        <div className="signin_main_div">
            <div className="signin_fields_div">
                <div className="signin_title_div">
                    {t(`we are sent verifacation code to ${maskEmail(email)}, please enter this code`)}
                </div>

                <div className="input_div">
                    <div>{t("Code")}</div>
                    <input
                        className={`input dir_ltr ${theme} ${requestStatus.error ? "error" : ""}`}
                        ref={passwordInputRef}
                        onChange={async (e) => {
                            setrecoveryInputValue(e.target.value);
                        }}
                    ></input>

                    {/* error */}
                    {
                        <div className="input_error_div">
                            {requestStatus.error}
                        </div>
                    }
                </div>

                <button
                    className={`submit_button ${theme} ${recoveryInputValue ? "active" : ""}`}
                    onClick={

                        recoveryInputValue ? () => verifyRecoveryCodeRequest(recoveryInputValue, otpId, navigate, setRequestStatus) : undefined
                    }
                >
                    {
                        requestStatus.loading
                            ? <img src="/icons/loading.png" className="rotate" />
                            : t("Next")
                    }
                </button>
            </div>
            <div className="buttons_div_in_signin1">
                <button
                    className={`simple_button ${theme}`}
                    onClick={() => navigate("/signin")}
                >
                    {t("Signin")}
                </button>
            </div>

            <div className="buttons_div_in_signin2">
                <button
                    className={`simple_button fontSize14 ${theme}`}
                    onClick={() => navigate("/rules")}
                >
                    {t("Rules")}
                </button>
                <button className={`simple_button fontSize14 ${theme}`}>{t("Language")}</button>
                <button
                    className={`simple_button fontSize14 ${theme}`}
                    onClick={() => {
                        setTheme(theme === "light" ? "night" : "light");
                    }}
                >
                    {theme === "light" ? t("Night mode") : t("Light mode")}
                </button>
            </div>

        </div>
    );
}

export default PasswordRecoveryStep2;
